import * as React from "react";
import View from "views/logic/views/View";
import {
  createElasticsearchQueryString,
  filtersToStreamSet,
  filtersToStreamCategorySet
} from "views/logic/queries/Query";
import useViewType from "views/hooks/useViewType";
import useCurrentQuery from "views/logic/queries/useCurrentQuery";
import useGlobalOverride from "views/hooks/useGlobalOverride";
import { DEFAULT_TIMERANGE } from "views/Constants";
import { concatQueryStrings } from "views/logic/queries/QueryHelper";
import DrilldownContext from "./DrilldownContext";
const useDrillDownContextValue = (widget, globalOverride, currentQuery) => {
  var _a;
  const viewType = useViewType();
  if (viewType === View.Type.Dashboard) {
    const { streams, timerange, query, streamCategories } = widget;
    const dashboardAndWidgetQueryString = ((_a = globalOverride == null ? void 0 : globalOverride.query) == null ? void 0 : _a.query_string) ? concatQueryStrings([query == null ? void 0 : query.query_string, globalOverride.query.query_string]) : query == null ? void 0 : query.query_string;
    return {
      streams,
      streamCategories,
      timerange: ((globalOverride == null ? void 0 : globalOverride.timerange) ? globalOverride.timerange : timerange) || DEFAULT_TIMERANGE,
      query: createElasticsearchQueryString(dashboardAndWidgetQueryString || "")
    };
  }
  if (currentQuery) {
    const streams = filtersToStreamSet(currentQuery.filter).toJS();
    const streamCategories = filtersToStreamCategorySet(currentQuery.filter).toJS();
    const { timerange, query } = currentQuery;
    return { streams, streamCategories, timerange, query };
  }
  return void 0;
};
const DrilldownContextProvider = ({ children, widget }) => {
  const currentQuery = useCurrentQuery();
  const globalOverride = useGlobalOverride();
  const drillDownContextValue = useDrillDownContextValue(widget, globalOverride, currentQuery);
  if (drillDownContextValue) {
    return /* @__PURE__ */ React.createElement(DrilldownContext.Provider, { value: drillDownContextValue }, children);
  }
  return children;
};
export default DrilldownContextProvider;
